// extracted by mini-css-extract-plugin
export default {"tasksPage":"PersonalTasksPage_tasksPage__lDYT6","tasksGrid":"PersonalTasksPage_tasksGrid__E1GKV","task":"PersonalTasksPage_task__lea4y","project":"PersonalTasksPage_project__-+Cpx"};